var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc663d;}.cls-2{fill:#f7cc94;}.cls-3{fill:#f4b392;}.cls-4{fill:#3f1400;}.cls-5{fill:none;stroke:#3f1400;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,44.5H4C4,37.61,7.13,32,14,32H34c6.89,0,10,5.58,10,12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.74,22.05V33.27a3.74,3.74,0,1,1-7.48,0V22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.41,18.3a10.33,10.33,0,0,1-3.67,7.39v2.49a5.86,5.86,0,0,1-7.48,0V25.69a10.33,10.33,0,0,1-3.67-7.39C17,13.39,20.18,9.57,24,9.57S31,13.39,31.41,18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.48,17.06a10,10,0,0,1-.07,1.24,10.33,10.33,0,0,1-3.67,7.39,5.86,5.86,0,0,1-7.48,0,10.33,10.33,0,0,1-3.67-7.39,10,10,0,0,1-.07-1.24c0-5.52,3.34-10,7.48-10S31.48,11.54,31.48,17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34,17.06a2.5,2.5,0,0,1-2.5,2.49c-1.37,0,0-1.12,0-2.49s-1.37-2.5,0-2.5A2.5,2.5,0,0,1,34,17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,17.06a2.5,2.5,0,0,0,2.5,2.49c1.37,0,0-1.12,0-2.49s1.37-2.5,0-2.5A2.5,2.5,0,0,0,14,17.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 21.01,
    cy: 14.81,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 26.99,
    cy: 14.81,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19.26,13.31s1.7-2,3.49-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.74,13.31s-1.7-2-3.49-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.5,15.31s-2,5-1,5h1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.5,22.3s3,0,4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.18,15.08s1-4.87,2.93-4.87,1.94,1,4.86,1,6.82,3.9,6.82,3.9,3.38-5.38-1-9.74c-1.95-1.94-6.82-2.92-9.74,0s-2.92,2-3.9,2-2.92,0-2.92,2S17.18,15.08,17.18,15.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.35c8ef508c6c0686defd01d07dd7bba9.svg";
export { ForwardRef as ReactComponent };